module.exports = __webpack_public_path__ + "img/5-fr.8be91e9d.jpg";